// extracted by mini-css-extract-plugin
export default {"carousel":"horizontalCarousel_carousel__uSv0B","carousel__container":"horizontalCarousel_carousel__container__uvotN","carousel__slide":"horizontalCarousel_carousel__slide__jOkUg"};